module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement06-5cf1fb1bae54209454d9c33f3bd4c31a.jpg";